import { render, staticRenderFns } from "./RegisterNewReturningTwo.vue?vue&type=template&id=3c09570c"
import script from "./RegisterNewReturningTwo.vue?vue&type=script&lang=js"
export * from "./RegisterNewReturningTwo.vue?vue&type=script&lang=js"
import style0 from "./RegisterNewReturningTwo.vue?vue&type=style&index=0&id=3c09570c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports